module.exports = __webpack_public_path__ + "img/3_afcd89c5f.png";